(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anm-editorial"] && !Shopify.designMode) return;
  try {
    
function initAnmWarnings(){
 document.querySelectorAll('.anm-warning').forEach(function(dialog){
  if(dialog.dataset.ready)return;
  dialog.dataset.ready='true';
  var accepted=false;
  try{accepted=sessionStorage.getItem('anm-warning-accepted')==='true'}catch(e){}
  if(!accepted && !window.Shopify?.designMode)dialog.showModal();
  dialog.addEventListener('close',function(){try{sessionStorage.setItem('anm-warning-accepted','true')}catch(e){}});
 });
}
initAnmWarnings();
document.addEventListener('shopify:section:load',initAnmWarnings);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
